//import Vue from 'vue';
//import moment from 'moment';
//import '../../filters';
import axios from 'axios';
import users from '@/users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';
import { v4 as uuidv4 } from 'uuid';

enum PenaltyType {
  None = 0,
  Percentage = 1,
  Fixed = 2
}

enum ChargeSchedule {
  ChargePerDate = 0,
  ChargePerBillingCycle = 1
}

enum InstallmentMethod {
  ByAmount = 0,
  ByInstallmentsNo = 1
}

export default {
  name: 'CustomerDetailsApplications',
    components: {
      DataGridComp: require('@/customcontrols/datagrid.vue').default,     
      LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
      EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  mixins: [users, enquiriesTools],
  props: {
    getIcon: {
      type: Function,
      required: true
    },
    isRtl: {
      type: Boolean,
      required: true
    },
    custKey: {
      type: String,
      required: true,
    }
  },
  data: function () {
    return {
      penaltyTypeDescription:
        [
          '',
          this.$t('enquiriesCustomerDetails.Percentage'),
          this.$t('enquiriesCustomerDetails.FixedAmount'),
        ],
      boolTrue: true,
      applicationsTotalRow: 0,
      applicationsPageingoptions: { pageSize: 10, total: 0, page: 1 },
      isLoading: false,
      Applications: [],
      ApplicationsCols: [],

      Agreements: [],
      AgreementsCols: [],
      agreementsTotalRow: 0,
      agreementsPageingoptions: { pageSize: 10, total: 0, page: 1 },
      selectedAgreement: {},
      showDialog: false,
      currSymbol: '',
    }
  },
  mounted() {
    this.fillGridColumns();
    this.fillApplications();

    this.currSymbol = this.$store.getters.getSettings.currencySymbol;

    //this.selectedAgrement = {
    //  "currencySymbol": "R", "agreemNo": -1, "reference": "160504_002", "account": "0100015", "customerName": "IMZ KHUMALO",
    //  "effectiveDate": "2016-05-04T00:00:00", "agreemAmount": 3465.36, "oustandingAmount": 3465.36, "vat": 0, "statusDescription": "Closed",
    //  "typeDescription": "Debt Rescheduling", "date": "04/05/2016", "guarantorName": "", "guarantorAddress": "", "guarantorId": "", "guarantorPhone": "",
    //  "guarantorEmail": "", "remarks": "", "oldRef": "", "installemntsNo": 4, "initialPayment": 870, "instDay": 1, "instMonth": 1, "instChargeSchedule": 0,
    //  "installmentMethod": 1, "instPenaltyType": 2, "instPenaltyValue": 20, "installments": [
    //    {
    //      "custkey": null, "agreemNo": 0, "instNo": 1, "chargeDate": "2016-06-01T00:00:00",
    //      "amount": 866.34, "transNo": 1, "receiptNo": null, "cumulativePaidAmount": null, "customerAgreement": null,
    //      "customerTransaction": null, "isCharged": false, "chargeDateFixed": "01/06/2016", "billingCycle": "Billing Cycle 1", "method": 1, "schedule": 0
    //    },
    //    {
    //      "custkey": null, "agreemNo": 0,
    //      "instNo": 2, "chargeDate": "2016-07-01T00:00:00",
    //      "amount": 866.34, "transNo": 1, "receiptNo": null,
    //      "cumulativePaidAmount": null, "customerAgreement": null,
    //      "customerTransaction": null, "isCharged": false, "chargeDateFixed": "01/07/2016",
    //      "billingCycle": "Billing Cycle 2", "method": 1, "schedule": 0
    //    },
    //    {
    //      "custkey": null, "agreemNo": 0, "instNo": 3, "chargeDate": "2016-08-01T00:00:00",
    //      "amount": 866.34, "transNo": 1, "receiptNo": null, "cumulativePaidAmount": null, "customerAgreement": null,
    //      "customerTransaction": null, "isCharged": false, "chargeDateFixed": "01/08/2016", "billingCycle": "Billing Cycle 3",
    //      "method": 1, "schedule": 0
    //    },
    //    {
    //      "custkey": null, "agreemNo": 0, "instNo": 4, "chargeDate": "2016-09-01T00:00:00", "amount": 866.34, "transNo": 1,
    //      "receiptNo": null, "cumulativePaidAmount": null, "customerAgreement": null, "customerTransaction": null,
    //      "isCharged": false, "chargeDateFixed": "01/09/2016", "billingCycle": "Billing Cycle 4", "method": 1, "schedule": 0
    //    }],
    //  "agreemNoAbs": 1, "effectiveDateDisplay": "04/05/2016"
    //};
  },
  computed: {
    showPercentFixedAmount: function () {
      return this.selectedAgreement.instPenaltyType == 1 ? `% (${this.$t('enquiriesCustomerDetails.Percentage')})` : `${this.currSymbol} (${this.$t('enquiriesCustomerDetails.FixedAmount')})`;
    }
  },
  watch: {},
  methods: {
    applicationsPageChange(pInfo) {
      this.applicationsPageingoptions.page = pInfo.pageNumber;
      this.applicationsPageingoptions.pageSize = pInfo.pageSize;
      this.fillApplications();
    },
    fillApplications() {
      if (!this.custKey)
        return;

      var parameters = {
        custKey: this.custKey,
        loginEmail: this.getLoginName(),
        Options: this.applicationsPageingoptions
      }

      this.isLoading = true;
      axios.post('/Enquiries/getCustomerApplications', parameters)
        .then(response => {
          if (response.status == 200) {
            this.Applications = response.data.items;

            this.applicationsTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.fillAgreements()) ;
    },
    applicationSelected(item) {
      if (item.data.sourceType == 1) {
        this.$oldAlertMsg(this.$t('enquiries.cantOpenOldApp'));
        return;
      }

      this.openNewWindow(`/application/${item.data.applicationId}`);
    },


    agreementsPageChange(pInfo) {
      this.agreementsPageingoptions.page = pInfo.pageNumber;
      this.agreementsPageingoptions.pageSize = pInfo.pageSize;
      this.fillAgreements();
    },
    fillAgreements() {
      var parameters = {
        custKey: this.custKey,
        loginEmail: this.getLoginName(),
        Options: this.agreementsPageingoptions
      }

      axios.post('/Enquiries/getCustomerAgreements', parameters)
        .then(response => {
          if (response.status == 200) {
            if (response.data.items && response.data.items.length > 0) {
              response.data.items.forEach(i => {
                i['agreemNoAbs'] = Math.abs(i.agreemNo)
                i.agreemAmount = this.$options.filters.twoDecimals(i.agreemAmount, true);
                i.oustandingAmount = this.$options.filters.twoDecimals(i.oustandingAmount, true);
                i.vat = this.$options.filters.twoDecimals(i.vat, true);
                if (i.installments)
                  i.installments.forEach(ins => ins.amount = this.$options.filters.twoDecimals(ins.amount, true));
              });
            }

            this.Agreements = response.data.items;
            this.agreementsTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.isLoading = false);
    },
    agreementSelected(item) {
      if (!item.data)
        return;

      item.data['instPenaltyType'] = item.data['instPenaltyType'] ?? 0;
      this.selectedAgreement = item.data;
      this.selectedAgreement.effectiveDateDisplay = this.$options.filters.formatDateDDMMYYY(this.selectedAgreement.effectiveDate);

      this.showDialog = true;
    },


    fillGridColumns() {
      this.ApplicationsCols.push({ dataField: 'sourceTypeS', caption: this.$t('enquiriesCustomerDetails.sourceTypeS') });
      this.ApplicationsCols.push({ dataField: 'applicationId', caption: this.$t('enquiriesCustomerDetails.applicationId') });
      this.ApplicationsCols.push({ dataField: 'applicationDate', caption: this.$t('enquiriesCustomerDetails.applicationDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.ApplicationsCols.push({ dataField: 'applicationType', caption: this.$t('enquiriesCustomerDetails.applicationType') });
      this.ApplicationsCols.push({ dataField: 'status', caption: this.$t('enquiriesCustomerDetails.status') });
      this.ApplicationsCols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesCustomerDetails.propertyRef') });
      this.ApplicationsCols.push({ dataField: 'address', caption: this.$t('enquiriesCustomerDetails.address') });
      this.ApplicationsCols.push({ dataField: 'hasDigitalSignatures', caption: this.$t('enquiriesCustomerDetails.hasDigitalSignatures') });


      this.AgreementsCols.push({ dataField: 'agreemNoAbs', caption: this.$t('enquiriesCustomerDetails.agreemNo') });
      this.AgreementsCols.push({ dataField: 'reference', caption: this.$t('enquiriesCustomerDetails.reference') });
      this.AgreementsCols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesCustomerDetails.effectiveDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.AgreementsCols.push({ dataField: 'agreemAmount', caption: this.$t('enquiriesCustomerDetails.agreemAmount') });
      this.AgreementsCols.push({ dataField: 'initialPayment', caption: this.$t('enquiriesCustomerDetails.immediatePayment') });
      this.AgreementsCols.push({ dataField: 'statusDescription', caption: this.$t('enquiriesCustomerDetails.status') });
      this.AgreementsCols.push({ dataField: 'typeDescription', caption: this.$t('enquiriesCustomerDetails.type') });
    },
  }
}

